export default "__VITE_ASSET__v84XFOYL__"